export const replaceMultipleSpacesWithSingleSpace = (text = '') => {
    // will also replace tabs, newlines, etc. we want this
    if (typeof text !== 'string') return text;

    return text.replace(/\s\s+/g, ' ').replace(/\n/g, ' ').trim();
};
